import { useRef } from 'react';
import { isDeepEqual } from 'remeda'; // Or implement your own deep equal function

export default function useDeepMemo<T>(memoFn: () => T, deps: unknown[]) {
  const ref = useRef<{ deps: unknown[] | null; value: T }>({
    deps: deps,
    value: memoFn(),
  });

  if (!ref.current.deps || !isDeepEqual(deps, ref.current.deps)) {
    ref.current = {
      deps,
      value: memoFn(),
    };
  }

  return ref.current.value;
}
